export enum UserRole {
  // Messages
  itAdmin = "ITAdmin",
  admin = "Admin",
  tenantUser = "TenantUser",
  tenantReader = "TenantReader",
  correspondentUser = "CorrespondentUser",
}
